module.exports = __webpack_public_path__ + "img/filter.77e52150.svg";